import { connect } from "nats.ws";

// Variabel untuk menyimpan koneksi NATS dan subscription yang aktif
let natsConnection = null;
const subscriptions = {};
let connectedUsers = new Set(); // Untuk melacak pengguna yang terhubung

// Fungsi untuk menghubungkan ke NATS
export const connectToNatsBwc = async () => {
  if (!natsConnection) {
    try {
      natsConnection = await connect({
        servers: "wss://facereco.grit.id:9002",
        token: "my_secure_token_123",
        debug: true,
      });
      console.log("Connected to NATS!");

      natsConnection.closed().then(() => {
        console.log("Disconnected from NATS!");
      });
    } catch (error) {
      console.error("Failed to connect to NATS:", error);
      throw new Error("Connection to NATS failed");
    }
  }
  return natsConnection;
};

// Menambahkan user ke daftar pengguna yang terhubung
export const addUserBwc = (userId) => {
  connectedUsers.add(userId);
  // console.log(`${userId} added to connected users`);
};

// Menghapus user dari daftar pengguna yang terhubung
export const removeUserBwc = (userId) => {
  connectedUsers.delete(userId);
  // console.log(`${userId} removed from connected users`);
};

// Fungsi untuk mengirim pesan (Publish)
export const publishMessageBwc = async (subject, message) => {
  try {
    const nc = await connectToNatsBwc();
    if (nc) {
      nc.publish(subject, JSON.stringify(message));
      // console.log(`Message sent to '${subject}' topic:`, message);
    }
  } catch (error) {
    console.error("Failed to publish message:", error);
  }
};

// Fungsi untuk berlangganan ke topik
export const subscribeToBwc = async (subject, callback, userId) => {
  try {
    const nc = await connectToNatsBwc();
    if (nc) {
      console.log(`Subscribed to '${subject}'`);

      // Menambahkan userId ke daftar pengguna yang terhubung
      addUserBwc(userId);

      const sub = nc.subscribe(subject);
      subscriptions[subject] = sub;

      (async () => {
        for await (const msg of sub) {
          const messageData = new TextDecoder().decode(msg.data);
          const parsedData = JSON.parse(messageData);
          callback(parsedData);
        }
      })();
    }
  } catch (error) {
    console.error(`Error subscribing to '${subject}':`, error);
  }
};

// Fungsi untuk berhenti berlangganan
export const unsubscribeMessageBwc = (subject, userId) => {
  const sub = subscriptions[subject];
  if (sub) {
    sub.unsubscribe();
    delete subscriptions[subject];
    removeUserBwc(userId); // Hapus user dari daftar terhubung
    console.log(`Unsubscribed from '${subject}'`);
  }
};

// Fungsi untuk mendapatkan daftar pengguna yang terhubung
export const getConnectedUsers = () => {
  // Mengembalikan array pengguna yang terhubung
  return Array.from(connectedUsers); 
};


